export default {
  // Actions sur les fichiers
  upload: 'Télécharger',
  download: 'Télécharger',
  delete: 'Supprimer',
  preview: 'Aperçu',
  view: 'Voir',
  editWithAI: 'Éditer avec IA',

  // Téléchargement de fichiers
  clickToUpload: 'Cliquer pour télécharger',
  orDragSingle: ' ou glisser un fichier ici',
  orDragMultiple: ' ou glisser plusieurs fichiers ici',
  uploading: 'Téléchargement...',
  uploadSuccess: '{{count}} fichier(s) téléchargé(s) avec succès',
  uploadFailed: 'Échec du téléchargement : {{files}}',

  // Validation des fichiers
  fileTooLarge: 'Le fichier est trop volumineux. Taille maximale : {size}MB',
  singleFileOnly: 'Un seul fichier peut être téléchargé à la fois',
  imagesOnly: 'Images uniquement',
  supportedFormats: 'Formats supportés : Images, PDF',

  // Informations sur le fichier
  fileSizeLabel: 'Taille du fichier',
  fileType: 'Type de fichier',
  filename: 'Nom du fichier',
  description: 'Description',
  file: 'Fichier',

  // Unités de taille de fichier
  fileSize: {
    zero: '0 Octets',
    bytes: 'Octets',
    kb: 'Ko',
    mb: 'Mo',
    gb: 'Go'
  },

  // Aperçu
  previewNotAvailable: 'Aperçu non disponible pour ce type de fichier',
  loading: 'Chargement...',

  // Contrôles d\'ordre
  moveUp: 'Monter',
  moveDown: 'Descendre',

  // Messages
  attachmentAdded: 'Pièce jointe ajoutée',
  attachmentRemoved: 'Pièce jointe supprimée',
  attachments: 'Pièces jointes',

  // Types spécifiques
  startPhotos: 'Photos de début',
  returnPhotos: 'Photos de retour',

  // Retour d'opérations
  fetchError: 'Échec du chargement des pièces jointes',
  deleteSuccess: 'Pièce jointe supprimée avec succès',
  deleteError: 'Échec de la suppression de la pièce jointe',
  orderUpdateSuccess: 'Ordre des pièces jointes mis à jour',
  orderUpdateError: 'Échec de la mise à jour de l\'ordre des pièces jointes',
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ?',

  // Édition IA
  aiEditPrompt: 'Décrivez comment vous voulez éditer cette image :',
  aiEditPlaceholder: 'ex: "Changer l\'arrière-plan en bleu", "Ajouter une ombre", "Rendre plus lumineux"',
  aiEditConfirm: 'Éditer l\'image',
  aiEditCancel: 'Annuler',
  aiEditSuccess: 'Image éditée avec succès',
  aiEditError: 'Échec de l\'édition de l\'image',
  aiEditInProgress: 'Édition de l\'image avec IA...',
  replaceOriginal: 'Remplacer l\'image originale',
  createNewCopy: 'Créer une nouvelle copie éditée',

  // Recadrage d'image
  crop: {
    title: 'Recadrer l\'image',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    zoom: 'Zoom',
    rotation: 'Rotation',
    aspectRatio: {
      label: 'Ratio d\'aspect',
      square: 'Carré (1:1)',
      landscape: 'Paysage (4:3)',
      portrait: 'Portrait (3:4)',
      wide: 'Large (16:9)'
    },
    success: 'Image recadrée avec succès',
    error: 'Échec du recadrage de l\'image',
    inProgress: 'Recadrage de l\'image...'
  },
};
